// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"252":"d08c568e","606":"7c30d61d"}[chunkId] + ".chunk.css";
};